import { acquireAccessToken } from '@shared/helpers/acquire-access-token/acquireAccessToken';
import { useCallback } from 'react';

import type { GetTokenFn } from './useGetToken.types';

/**
 * Hook that provides a stable `getToken` callback for MFEs.
 *
 * MFEs can call this function to get a fresh access token on every API request,
 * instead of relying on a static token captured at mount time.
 * The Host App handles all token refresh logic (silent refresh, retry, expiry detection).
 *
 * Backward compatibility:
 * - The `msalInstance` prop is still passed to MFEs for legacy support.
 * - MFEs that support the new `getToken` callback should prefer it over using `msalInstance` directly.
 * - The `getToken` prop is optional so that old MFEs continue to work without changes.
 *
 * @returns A stable callback that resolves to the current access token string.
 */
export function useGetToken(): GetTokenFn {
  return useCallback(() => acquireAccessToken(), []);
}
